import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import { PATH } from 'types/router';
import { AboutSubscription, MoreInfoLink } from 'containers/VideoInfo/SvodInfo';
import _ from 'lodash';
import { SvodButtonsStyled } from './styles/SvodButtonsStyled';

const SvodButtons = ({ isAvailable, goTo, translate, subscriptionInfo, isTnB, geo, isMobile }) => {
  let extraProps;
  if (isAvailable) {
    extraProps = {
      text: translate('watch'),
      icon: 'play',
      iconSize: 12,
      onClick: () => goTo(PATH.PLAYER),
    };
  } else if (isTnB) {
    extraProps = {
      text: `${translate('try')} ${translate('for_price', {
        price: _.get(subscriptionInfo, 'tariffs.0.priceText'),
      })}`,
      onClick: () => goTo(PATH.SUBSCRIPTION_TARIFF_SELECT),
    };
  } else {
    extraProps = {
      text: translate('get_subscription'),
      onClick: () => goTo(PATH.SUBSCRIPTION_TARIFF_SELECT),
    };
  }
  return (
    <SvodButtonsStyled>
      <Button
        buttonStyle="background"
        textSize="xs"
        size="l"
        align="center"
        textColor="white"
        isMobile={isMobile}
        {...extraProps}
      />
      {isTnB &&
        !isAvailable && (
          <AboutSubscription translate={translate} subscriptionInfo={subscriptionInfo} geo={geo} />
        )}

      {isAvailable && <MoreInfoLink translate={translate} geo={geo} />}
    </SvodButtonsStyled>
  );
};

SvodButtons.propTypes = {
  isAvailable: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  geo: PropTypes.string.isRequired,
  subscriptionInfo: PropTypes.object.isRequired,
  isTnB: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
};

SvodButtons.defaultProps = {
  isMobile: false,
};

export default SvodButtons;
